<template>
  <app-modal name="company-license-modal" :title="title" @before-open="beforeOpen" hide-footer>
    <div class="company-license row">
      <div v-for="(sub) in subscriptions" class="col-md-8 offset-md-2 text-center">
        <div class="card mb-4 box-shadow" v-if="sub.plan_id.id">
          <div class="top-right-corner">
            <strong>
              {{$t('user.companyLicense')}}
            </strong>

          </div>
<!--          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{$t(`user.subscriptionPlan.${sub.plan_id.name}`)}}</h4>
          </div>-->
          <div class="card-body">
            <img class="logo" width="150px" src="/images/license.png" alt="PVS License">
            <h3 class="font-weight-bold">
              <strong>
                {{$t('invoice.invoices')}}
              </strong>
            </h3>
            <ul class="list-unstyled mt-2 mb-4">
              <li>
                <strong>
                  {{$t('user.subscriptionPlan.start')}}: {{sub.start | formatDate}}
                </strong>
              </li>
              <li class="mt-2 light-grey">{{$t('user.subscriptionPlan.usage')}}: {{sub.plan_id.capacity}}/{{sub.plan_id.total}}</li>
              <li class="mt-4">
                <strong>
                  {{$t('user.subscriptionPlan.price')}}
                </strong>
              </li>
              <li class="mt-2">
                <h3>
                  <strong class="primary-color">
                    {{sub.plan_id.price| formatNumber}} VNĐ
                  </strong>
                </h3>
              </li>
            </ul>
            <a target="_blank" href="https://pvssolution.com/lien-he/" class="btn btn-primary">
              {{$t('user.subscriptionPlan.buyMore')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import LicenseProxy from '@/store/proxies/license-proxy';

export default {
  name: 'CompanyLicenseModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: '',
      subscriptions: [],
      planName: {

      },
    };
  },
  methods: {
    beforeOpen() {
      new LicenseProxy().getSubscriptions().then((subscriptions) => {
        this.subscriptions = subscriptions;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/user/company-license-modal.vue